module.exports = __webpack_public_path__ + "d308073b/img/comments-icon.fdec7fdb.svg";